var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Three60Environment',{attrs:{"panos":_vm.pageData.origin.panoramas,"heading":_vm.pageData.origin.heading,"copy":_vm.pageData.origin.overview}})
}
var staticRenderFns = []

export { render, staticRenderFns }